<template>
  <div class="dash-card kpi-card">
    <component :is="to ? 'router-link' : 'div'" :to="to" :class="['kpi-tile', to ? 'kpi-link' : '', compact ? 'kpi-compact' : '']">
      <div :class="['kpi-icon', `tint-${tint}`]">
        <i :class="['pi', icon]"></i>
      </div>
      <div class="kpi-content">
        <div class="kpi-label" :title="label">{{ label }}</div>
        <div v-if="loading" class="dash-skeleton" style="height: 26px; width: 60%; margin: 4px 0 8px 0;"></div>
        <div v-else class="kpi-value">
          {{ displayValue }}<small v-if="unit">{{ unit }}</small>
        </div>
        <div v-if="loading" class="dash-skeleton" style="height: 12px; width: 80%;"></div>
        <div v-else-if="sub || delta !== null" class="kpi-sub">
          <span v-if="delta !== null" :class="['kpi-delta', deltaClass]">
            <i :class="['pi', delta > 0 ? 'pi-arrow-up' : delta < 0 ? 'pi-arrow-down' : 'pi-minus']"></i>
            {{ Math.abs(delta) }}{{ deltaSuffix }}
          </span>
          <span v-if="sub">{{ sub }}</span>
        </div>
        <slot></slot>
      </div>
    </component>
  </div>
</template>

<script>
export default {
  name: 'DashboardStatCard',
  props: {
    label: { type: String, required: true },
    value: { type: [String, Number], default: '-' },
    unit: { type: String, default: '' },
    sub: { type: String, default: '' },
    icon: { type: String, default: 'pi-chart-bar' },
    tint: { type: String, default: 'green' },
    delta: { type: Number, default: null },
    deltaSuffix: { type: String, default: '' },
    invertDelta: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    compact: { type: Boolean, default: false },
    to: { type: Object, default: null },
  },
  computed: {
    displayValue() {
      if (this.value === null || this.value === undefined || this.value === '') return '-';
      return this.value;
    },
    deltaClass() {
      if (this.delta === null || this.delta === 0) return 'neutral';
      const positive = this.delta > 0;
      const good = this.invertDelta ? !positive : positive;
      return good ? 'up' : 'down';
    },
  },
};
</script>

<style scoped>
.kpi-card {
  height: calc(100% - 1.25rem);
}
</style>
